module.exports = __webpack_public_path__ + "img/fengjing.00b86c0b.jpg";